import { CustomAttributeDefinition, FORM_MODE } from '../../CAD.types';
import { CADForm } from '../CADForm';

export interface CADAddProps {
	hasEntitlement: boolean;
	loading: boolean;
	goToForbiddenPage: Function;
	onCancel: () => void;
	onSubmit: (definition: CustomAttributeDefinition) => void;
}

export function CADAdd({
	hasEntitlement,
	loading,
	goToForbiddenPage,
	onCancel,
	onSubmit,
}: CADAddProps) {
	if (!hasEntitlement) {
		goToForbiddenPage();
	}

	// TODO: see how to handle the removed Layout from Catalog
	return <CADForm mode={FORM_MODE.ADD} loading={loading} onCancel={onCancel} onSubmit={onSubmit} />;
}

CADAdd.displayName = 'CADAdd';
